import { useIconContext } from '../contexts';
import { DATA_FUI_ICON } from '../utils/constants';
/**
 * Styling-agnostic icon state shared by the Griffel and headless APIs.
 *
 * Handles the parts that are identical regardless of styling strategy:
 * - strips non-DOM props (`filled`)
 * - maps `primaryFill` -> `fill`
 * - applies a11y (`title` -> `aria-label`, otherwise `aria-hidden`; `role="img"`)
 * - sets the base `data-fui-icon` attribute so any icon is CSS-selectable
 * - resolves the RTL flip decision from icon context
 *
 * Callers layer their own className / additional `data-*` attribute styling on
 * top, and apply the visual RTL flip using `isRtlFlip`.
 */
export const useBaseIconState = (props, options) => {
    const { 
    // remove unwanted props to be set on the svg/html element
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    filled, 
    // consumed by the icon factory to scope color-icon ids, never a DOM attribute
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    idPrefix, title, primaryFill = 'currentColor', ...rest } = props;
    const state = {
        ...rest,
        fill: primaryFill,
    };
    const iconContext = useIconContext();
    const isRtlFlip = Boolean((options === null || options === void 0 ? void 0 : options.flipInRtl) && (iconContext === null || iconContext === void 0 ? void 0 : iconContext.textDirection) === 'rtl');
    if (title) {
        state['aria-label'] = title;
    }
    if (!state['aria-label'] && !state['aria-labelledby']) {
        state['aria-hidden'] = true;
    }
    else {
        state['role'] = 'img';
    }
    // Universal data attribute so any icon (SVG or font) can be targeted via `[data-fui-icon]`.
    state[DATA_FUI_ICON] = '';
    return { state, isRtlFlip };
};
